export enum ActionTopic {
    Update = 1,
    AuxiliaryRouteChange = 2,
    TemplateChange = 3,
    ValidationSuccess = 4,
    ValidationFailure = 5,
    TransactionChanging = 6,
    TabTitleChange = 7,
    UpdateActionSet = 8,
    UpdateWip = 9,
    TransactionLoaded = 10,
    TabChange = 11,
    TransactionDeleted = 12,
    RouteConfigurationChange = 13,
    TemplateTitleChange = 14,
    SummaryInformationUpdated = 15, // this is used by tab hover over
    ValidationGroupChange = 16,
    ServiceRefresh = 17,
    SearchResultsReturned = 18,
    ResultsReturned = 19,
    InvokeCommand = 20,
    CreditAmountCalculated = 21,
    ConfirmationWarningApproved = 22,
    TitleChange = 23,
    CreditPrimaryCustomer = 24,
    EnableButtons = 25,
    DisableButtons = 26,
    ShowOverlay = 27,
    HideOverlay = 28,
    VehicleInformationRefreshRegistration = 29,
    RefreshWithdrawals = 30

}
